/* tslint:disable */
export var wrapper;
(function (wrapper) {
    var wix;
    (function (wix) {
        var feed;
        (function (feed) {
            var FeedItemPermission;
            (function (FeedItemPermission) {
                FeedItemPermission["CREATE"] = "CREATE";
                FeedItemPermission["EDIT"] = "EDIT";
                FeedItemPermission["DELETE"] = "DELETE";
                FeedItemPermission["REACT"] = "REACT";
                FeedItemPermission["REPORT"] = "REPORT";
                FeedItemPermission["ADD_COMMENT"] = "ADD_COMMENT";
                FeedItemPermission["PIN"] = "PIN";
            })(FeedItemPermission = feed.FeedItemPermission || (feed.FeedItemPermission = {}));
            var component;
            (function (component) {
                var FeedComponentService = /** @class */ (function () {
                    function FeedComponentService() {
                    }
                    return FeedComponentService;
                }());
                component.FeedComponentService = FeedComponentService;
                var Role;
                (function (Role) {
                    Role["VIEWER"] = "VIEWER";
                    Role["WRITER"] = "WRITER";
                    Role["ADMIN"] = "ADMIN";
                })(Role = component.Role || (component.Role = {}));
            })(component = feed.component || (feed.component = {}));
            var ContentPreviewService = /** @class */ (function () {
                function ContentPreviewService() {
                }
                return ContentPreviewService;
            }());
            feed.ContentPreviewService = ContentPreviewService;
            var FeedMigrationService = /** @class */ (function () {
                function FeedMigrationService() {
                }
                return FeedMigrationService;
            }());
            feed.FeedMigrationService = FeedMigrationService;
            var FeedService = /** @class */ (function () {
                function FeedService() {
                }
                return FeedService;
            }());
            feed.FeedService = FeedService;
            var PinPolicy;
            (function (PinPolicy) {
                var OnExceedAllowedPins;
                (function (OnExceedAllowedPins) {
                    OnExceedAllowedPins["RESPOND_WITH_ALREADY_EXISTS"] = "RESPOND_WITH_ALREADY_EXISTS";
                    OnExceedAllowedPins["REPLACE_OLDEST"] = "REPLACE_OLDEST";
                })(OnExceedAllowedPins = PinPolicy.OnExceedAllowedPins || (PinPolicy.OnExceedAllowedPins = {}));
            })(PinPolicy = feed.PinPolicy || (feed.PinPolicy = {}));
        })(feed = wix.feed || (wix.feed = {}));
        var comments;
        (function (comments) {
            var Ordering;
            (function (Ordering) {
                Ordering["OLDEST_FIRST"] = "OLDEST_FIRST";
                Ordering["LATEST_FIRST"] = "LATEST_FIRST";
            })(Ordering = comments.Ordering || (comments.Ordering = {}));
            var UserAction;
            (function (UserAction) {
                UserAction["VIEW"] = "VIEW";
                UserAction["ADD_COMMENT"] = "ADD_COMMENT";
                UserAction["REACT"] = "REACT";
                UserAction["UNREACT"] = "UNREACT";
                UserAction["REPORT"] = "REPORT";
                UserAction["EDIT"] = "EDIT";
                UserAction["DELETE"] = "DELETE";
            })(UserAction = comments.UserAction || (comments.UserAction = {}));
            var ReportType;
            (function (ReportType) {
                ReportType["UNWANTED_CONTENT"] = "UNWANTED_CONTENT";
                ReportType["HARASSMENT"] = "HARASSMENT";
                ReportType["INAPPROPRIATE_CONTENT"] = "INAPPROPRIATE_CONTENT";
                ReportType["HATE_SPEECH_OR_GRAPHIC"] = "HATE_SPEECH_OR_GRAPHIC";
                ReportType["OTHER"] = "OTHER";
                ReportType["UnwantedContent"] = "UnwantedContent";
                ReportType["Harrasment"] = "Harrasment";
                ReportType["InappropiateContent"] = "InappropiateContent";
                ReportType["HateSpeechOrGraphic"] = "HateSpeechOrGraphic";
            })(ReportType = comments.ReportType || (comments.ReportType = {}));
            var component;
            (function (component) {
                var CommentsHostedSpi = /** @class */ (function () {
                    function CommentsHostedSpi() {
                    }
                    return CommentsHostedSpi;
                }());
                component.CommentsHostedSpi = CommentsHostedSpi;
                var CommentsComponentService = /** @class */ (function () {
                    function CommentsComponentService() {
                    }
                    return CommentsComponentService;
                }());
                component.CommentsComponentService = CommentsComponentService;
                var Permission;
                (function (Permission) {
                    Permission["VIEWER"] = "VIEWER";
                    Permission["WRITER"] = "WRITER";
                    Permission["ADMIN"] = "ADMIN";
                })(Permission = component.Permission || (component.Permission = {}));
                var Feature;
                (function (Feature) {
                    Feature["ALL"] = "ALL";
                    Feature["REPLIES"] = "REPLIES";
                    Feature["REACTIONS"] = "REACTIONS";
                })(Feature = component.Feature || (component.Feature = {}));
            })(component = comments.component || (comments.component = {}));
            var CommentsSeoService = /** @class */ (function () {
                function CommentsSeoService() {
                }
                return CommentsSeoService;
            }());
            comments.CommentsSeoService = CommentsSeoService;
            var CommentsService = /** @class */ (function () {
                function CommentsService() {
                }
                return CommentsService;
            }());
            comments.CommentsService = CommentsService;
            var gdpr;
            (function (gdpr) {
                var GdprService = /** @class */ (function () {
                    function GdprService() {
                    }
                    return GdprService;
                }());
                gdpr.GdprService = GdprService;
                var GdprComment;
                (function (GdprComment) {
                    var Status;
                    (function (Status) {
                        Status["CREATED"] = "CREATED";
                        Status["REMOVED"] = "REMOVED";
                    })(Status = GdprComment.Status || (GdprComment.Status = {}));
                })(GdprComment = gdpr.GdprComment || (gdpr.GdprComment = {}));
            })(gdpr = comments.gdpr || (comments.gdpr = {}));
            var FeedPageCursor;
            (function (FeedPageCursor) {
                var PriorityTag;
                (function (PriorityTag) {
                    PriorityTag["REMAINING"] = "REMAINING";
                    PriorityTag["PINNED"] = "PINNED";
                })(PriorityTag = FeedPageCursor.PriorityTag || (FeedPageCursor.PriorityTag = {}));
            })(FeedPageCursor = comments.FeedPageCursor || (comments.FeedPageCursor = {}));
        })(comments = wix.comments || (wix.comments = {}));
        var api;
        (function (api) {
            var Exposure;
            (function (Exposure) {
                Exposure["PRIVATE"] = "PRIVATE";
                Exposure["INTERNAL"] = "INTERNAL";
                Exposure["PUBLIC"] = "PUBLIC";
            })(Exposure = api.Exposure || (api.Exposure = {}));
            var Maturity;
            (function (Maturity) {
                Maturity["ALPHA"] = "ALPHA";
                Maturity["BETA"] = "BETA";
                Maturity["IA"] = "IA";
                Maturity["GA"] = "GA";
            })(Maturity = api.Maturity || (api.Maturity = {}));
            var Format;
            (function (Format) {
                Format["EMAIL"] = "EMAIL";
                Format["HOSTNAME"] = "HOSTNAME";
                Format["IPV4"] = "IPV4";
                Format["IPV6"] = "IPV6";
                Format["URI"] = "URI";
                Format["WEB_URL"] = "WEB_URL";
                Format["PHONE"] = "PHONE";
                Format["CREDIT_CARD"] = "CREDIT_CARD";
                Format["GUID"] = "GUID";
                Format["COUNTRY"] = "COUNTRY";
                Format["LANGUAGE"] = "LANGUAGE";
                Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
                Format["CURRENCY"] = "CURRENCY";
                Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
            })(Format = api.Format || (api.Format = {}));
        })(api = wix.api || (wix.api = {}));
        var reactions;
        (function (reactions) {
            var ReactionsService = /** @class */ (function () {
                function ReactionsService() {
                }
                return ReactionsService;
            }());
            reactions.ReactionsService = ReactionsService;
        })(reactions = wix.reactions || (wix.reactions = {}));
        var common;
        (function (common) {
            var SortOrder;
            (function (SortOrder) {
                SortOrder["ASC"] = "ASC";
                SortOrder["DESC"] = "DESC";
            })(SortOrder = common.SortOrder || (common.SortOrder = {}));
            var VatType;
            (function (VatType) {
                VatType["UNSPECIFIED"] = "UNSPECIFIED";
                VatType["CPF"] = "CPF";
                VatType["CNPJ"] = "CNPJ";
            })(VatType = common.VatType || (common.VatType = {}));
        })(common = wix.common || (wix.common = {}));
        var social;
        (function (social) {
            var IdentityType;
            (function (IdentityType) {
                IdentityType["ANONYMOUS"] = "ANONYMOUS";
                IdentityType["MEMBER"] = "MEMBER";
                IdentityType["USER"] = "USER";
            })(IdentityType = social.IdentityType || (social.IdentityType = {}));
            var ContentType;
            (function (ContentType) {
                ContentType["PLAIN_TEXT"] = "PLAIN_TEXT";
                ContentType["DRAFTJS"] = "DRAFTJS";
            })(ContentType = social.ContentType || (social.ContentType = {}));
            var MediaType;
            (function (MediaType) {
                MediaType["ATTACHMENT"] = "ATTACHMENT";
                MediaType["IMAGE"] = "IMAGE";
                MediaType["VIDEO"] = "VIDEO";
            })(MediaType = social.MediaType || (social.MediaType = {}));
            var ActivitiesService = /** @class */ (function () {
                function ActivitiesService() {
                }
                return ActivitiesService;
            }());
            social.ActivitiesService = ActivitiesService;
            var ContentContainersService = /** @class */ (function () {
                function ContentContainersService() {
                }
                return ContentContainersService;
            }());
            social.ContentContainersService = ContentContainersService;
            var DbManagementService = /** @class */ (function () {
                function DbManagementService() {
                }
                return DbManagementService;
            }());
            social.DbManagementService = DbManagementService;
            var EventOrdering;
            (function (EventOrdering) {
                EventOrdering["LATEST"] = "LATEST";
                EventOrdering["OLDEST"] = "OLDEST";
            })(EventOrdering = social.EventOrdering || (social.EventOrdering = {}));
            var ManagementService = /** @class */ (function () {
                function ManagementService() {
                }
                return ManagementService;
            }());
            social.ManagementService = ManagementService;
            var ProfilesService = /** @class */ (function () {
                function ProfilesService() {
                }
                return ProfilesService;
            }());
            social.ProfilesService = ProfilesService;
            var groups;
            (function (groups) {
                var api;
                (function (api) {
                    var v1;
                    (function (v1) {
                        var SocialGroupsAppsService = /** @class */ (function () {
                            function SocialGroupsAppsService() {
                            }
                            return SocialGroupsAppsService;
                        }());
                        v1.SocialGroupsAppsService = SocialGroupsAppsService;
                        var GroupPrivacyLevel;
                        (function (GroupPrivacyLevel) {
                            GroupPrivacyLevel["SECRET"] = "SECRET";
                            GroupPrivacyLevel["PRIVATE"] = "PRIVATE";
                            GroupPrivacyLevel["PUBLIC"] = "PUBLIC";
                        })(GroupPrivacyLevel = v1.GroupPrivacyLevel || (v1.GroupPrivacyLevel = {}));
                        var RelationshipWithGroup;
                        (function (RelationshipWithGroup) {
                            RelationshipWithGroup["NONE"] = "NONE";
                            RelationshipWithGroup["JOINED"] = "JOINED";
                            RelationshipWithGroup["PENDING_APPROVAL"] = "PENDING_APPROVAL";
                            RelationshipWithGroup["REJECTED_MEMBERSHIP"] = "REJECTED_MEMBERSHIP";
                        })(RelationshipWithGroup = v1.RelationshipWithGroup || (v1.RelationshipWithGroup = {}));
                        var RoleInGroup;
                        (function (RoleInGroup) {
                            RoleInGroup["GROUP_MEMBER"] = "GROUP_MEMBER";
                            RoleInGroup["GROUP_ADMIN"] = "GROUP_ADMIN";
                            RoleInGroup["SITE_ADMIN"] = "SITE_ADMIN";
                        })(RoleInGroup = v1.RoleInGroup || (v1.RoleInGroup = {}));
                        var GroupAppKey;
                        (function (GroupAppKey) {
                            GroupAppKey["MEMBERS_APP"] = "MEMBERS_APP";
                            GroupAppKey["FEED_APP"] = "FEED_APP";
                            GroupAppKey["ABOUT_APP"] = "ABOUT_APP";
                            GroupAppKey["GALLERY_APP"] = "GALLERY_APP";
                        })(GroupAppKey = v1.GroupAppKey || (v1.GroupAppKey = {}));
                        var GroupsSortBy;
                        (function (GroupsSortBy) {
                            GroupsSortBy["RECENT_ACTIVITY"] = "RECENT_ACTIVITY";
                            GroupsSortBy["NAME"] = "NAME";
                            GroupsSortBy["MEMBERS_COUNT"] = "MEMBERS_COUNT";
                        })(GroupsSortBy = v1.GroupsSortBy || (v1.GroupsSortBy = {}));
                        var CreateGroupsPolicy;
                        (function (CreateGroupsPolicy) {
                            CreateGroupsPolicy["ONLY_ME"] = "ONLY_ME";
                            CreateGroupsPolicy["MEMBERS"] = "MEMBERS";
                            CreateGroupsPolicy["MEMBERS_WITH_MY_APPROVAL"] = "MEMBERS_WITH_MY_APPROVAL";
                        })(CreateGroupsPolicy = v1.CreateGroupsPolicy || (v1.CreateGroupsPolicy = {}));
                        var GroupApprovalStatus;
                        (function (GroupApprovalStatus) {
                            GroupApprovalStatus["EMPTY"] = "EMPTY";
                            GroupApprovalStatus["PENDING"] = "PENDING";
                            GroupApprovalStatus["APPROVED"] = "APPROVED";
                            GroupApprovalStatus["REJECTED"] = "REJECTED";
                            GroupApprovalStatus["CANCELLED"] = "CANCELLED";
                        })(GroupApprovalStatus = v1.GroupApprovalStatus || (v1.GroupApprovalStatus = {}));
                        var SocialGroupsMediaIntegrationService = /** @class */ (function () {
                            function SocialGroupsMediaIntegrationService() {
                            }
                            return SocialGroupsMediaIntegrationService;
                        }());
                        v1.SocialGroupsMediaIntegrationService = SocialGroupsMediaIntegrationService;
                        var SocialGroupsFeedIntegrationService = /** @class */ (function () {
                            function SocialGroupsFeedIntegrationService() {
                            }
                            return SocialGroupsFeedIntegrationService;
                        }());
                        v1.SocialGroupsFeedIntegrationService = SocialGroupsFeedIntegrationService;
                        var SocialGroupsPageRoutingService = /** @class */ (function () {
                            function SocialGroupsPageRoutingService() {
                            }
                            return SocialGroupsPageRoutingService;
                        }());
                        v1.SocialGroupsPageRoutingService = SocialGroupsPageRoutingService;
                        var TriggerRemindersToCreateGroupRequestMode;
                        (function (TriggerRemindersToCreateGroupRequestMode) {
                            TriggerRemindersToCreateGroupRequestMode["TEST_MODE"] = "TEST_MODE";
                            TriggerRemindersToCreateGroupRequestMode["PROD_MODE"] = "PROD_MODE";
                        })(TriggerRemindersToCreateGroupRequestMode = v1.TriggerRemindersToCreateGroupRequestMode || (v1.TriggerRemindersToCreateGroupRequestMode = {}));
                        var SocialGroupsNotificationTriggerService = /** @class */ (function () {
                            function SocialGroupsNotificationTriggerService() {
                            }
                            return SocialGroupsNotificationTriggerService;
                        }());
                        v1.SocialGroupsNotificationTriggerService = SocialGroupsNotificationTriggerService;
                        var SocialGroupsGdprService = /** @class */ (function () {
                            function SocialGroupsGdprService() {
                            }
                            return SocialGroupsGdprService;
                        }());
                        v1.SocialGroupsGdprService = SocialGroupsGdprService;
                        var SocialGroupsInternalService = /** @class */ (function () {
                            function SocialGroupsInternalService() {
                            }
                            return SocialGroupsInternalService;
                        }());
                        v1.SocialGroupsInternalService = SocialGroupsInternalService;
                        var SocialGroupsService = /** @class */ (function () {
                            function SocialGroupsService() {
                            }
                            return SocialGroupsService;
                        }());
                        v1.SocialGroupsService = SocialGroupsService;
                        var SocialGroupsMembershipService = /** @class */ (function () {
                            function SocialGroupsMembershipService() {
                            }
                            return SocialGroupsMembershipService;
                        }());
                        v1.SocialGroupsMembershipService = SocialGroupsMembershipService;
                        var SocialGroupsInviteService = /** @class */ (function () {
                            function SocialGroupsInviteService() {
                            }
                            return SocialGroupsInviteService;
                        }());
                        v1.SocialGroupsInviteService = SocialGroupsInviteService;
                        var MigrationType;
                        (function (MigrationType) {
                            MigrationType["TEST"] = "TEST";
                            MigrationType["DEFAULT_SORT_BY_MIGRATION"] = "DEFAULT_SORT_BY_MIGRATION";
                            MigrationType["REMINDERS_CLEANUP"] = "REMINDERS_CLEANUP";
                            MigrationType["PENDING_JRS_FOR_PUBLIC_GROUPS_CLEANUP"] = "PENDING_JRS_FOR_PUBLIC_GROUPS_CLEANUP";
                            MigrationType["UPDATE_MEMBERSHIP_ROLE"] = "UPDATE_MEMBERSHIP_ROLE";
                        })(MigrationType = v1.MigrationType || (v1.MigrationType = {}));
                        var SocialGroupsMigrationService = /** @class */ (function () {
                            function SocialGroupsMigrationService() {
                            }
                            return SocialGroupsMigrationService;
                        }());
                        v1.SocialGroupsMigrationService = SocialGroupsMigrationService;
                        var NotificationChannel;
                        (function (NotificationChannel) {
                            NotificationChannel["WEB"] = "WEB";
                            NotificationChannel["MOBILE"] = "MOBILE";
                            NotificationChannel["EMAIL"] = "EMAIL";
                        })(NotificationChannel = v1.NotificationChannel || (v1.NotificationChannel = {}));
                        var NotificationType;
                        (function (NotificationType) {
                            NotificationType["ALL"] = "ALL";
                            NotificationType["POST"] = "POST";
                            NotificationType["COMMENT"] = "COMMENT";
                            NotificationType["REACTION"] = "REACTION";
                            NotificationType["MEMBERSHIP"] = "MEMBERSHIP";
                        })(NotificationType = v1.NotificationType || (v1.NotificationType = {}));
                        var SocialGroupsNotificationSettingsService = /** @class */ (function () {
                            function SocialGroupsNotificationSettingsService() {
                            }
                            return SocialGroupsNotificationSettingsService;
                        }());
                        v1.SocialGroupsNotificationSettingsService = SocialGroupsNotificationSettingsService;
                        var SocialGroupsRolesService = /** @class */ (function () {
                            function SocialGroupsRolesService() {
                            }
                            return SocialGroupsRolesService;
                        }());
                        v1.SocialGroupsRolesService = SocialGroupsRolesService;
                        var SocialGroupsRulesService = /** @class */ (function () {
                            function SocialGroupsRulesService() {
                            }
                            return SocialGroupsRulesService;
                        }());
                        v1.SocialGroupsRulesService = SocialGroupsRulesService;
                    })(v1 = api.v1 || (api.v1 = {}));
                })(api = groups.api || (groups.api = {}));
            })(groups = social.groups || (social.groups = {}));
        })(social = wix.social || (wix.social = {}));
    })(wix = wrapper.wix || (wrapper.wix = {}));
    var com;
    (function (com) {
        var wix;
        (function (wix) {
            var core;
            (function (core) {
                var services;
                (function (services) {
                    var identification2;
                    (function (identification2) {
                        var PersonType;
                        (function (PersonType) {
                            PersonType["USER"] = "USER";
                            PersonType["SITEMEMBER"] = "SITEMEMBER";
                            PersonType["VISITOR"] = "VISITOR";
                        })(PersonType = identification2.PersonType || (identification2.PersonType = {}));
                        var IdentificationServiceV2 = /** @class */ (function () {
                            function IdentificationServiceV2() {
                            }
                            return IdentificationServiceV2;
                        }());
                        identification2.IdentificationServiceV2 = IdentificationServiceV2;
                    })(identification2 = services.identification2 || (services.identification2 = {}));
                })(services = core.services || (core.services = {}));
            })(core = wix.core || (wix.core = {}));
        })(wix = com.wix || (com.wix = {}));
        var wixpress;
        (function (wixpress) {
            var metasite;
            (function (metasite) {
                var reloose;
                (function (reloose) {
                    var api;
                    (function (api) {
                        var App;
                        (function (App) {
                            var State;
                            (function (State) {
                                State["UNKNOWN"] = "UNKNOWN";
                                State["ENABLED"] = "ENABLED";
                                State["DISABLED"] = "DISABLED";
                                State["TEMPLATE"] = "TEMPLATE";
                                State["PENDING"] = "PENDING";
                            })(State = App.State || (App.State = {}));
                        })(App = api.App || (api.App = {}));
                        var RelooseApi = /** @class */ (function () {
                            function RelooseApi() {
                            }
                            return RelooseApi;
                        }());
                        api.RelooseApi = RelooseApi;
                    })(api = reloose.api || (reloose.api = {}));
                })(reloose = metasite.reloose || (metasite.reloose = {}));
            })(metasite = wixpress.metasite || (wixpress.metasite = {}));
        })(wixpress = com.wixpress || (com.wixpress = {}));
    })(com = wrapper.com || (wrapper.com = {}));
})(wrapper || (wrapper = {}));
//# sourceMappingURL=proto-generated.js.map